import VariantZone from './variantZone';

export function findZoneInDomNode(domNode = document) {
	const zoneElement = domNode.querySelector('[data-product-variant-zone]');

	return zoneElement ? new VariantZone(zoneElement) : null;
}

export function renderZone(variantZone, results) {
	if (!variantZone) {
		return Promise.resolve();
	}

	const zoneResult = results?.find(
		result => result.zoneId === variantZone.placementId,
	);

	if (!zoneResult?.variantGroups?.length) {
		return Promise.resolve();
	}

	variantZone.addResults(zoneResult);

	return variantZone.requestRender();
}
